import { render } from "./DictManager.vue?vue&type=template&id=3b2a99e0&scoped=true"
import script from "./DictManager.vue?vue&type=script&lang=js"
export * from "./DictManager.vue?vue&type=script&lang=js"

import "./DictManager.vue?vue&type=style&index=0&id=3b2a99e0&scoped=true&lang=css"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b2a99e0"]])

export default __exports__